var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 11,
    viewBox: "0 0 33 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7539_15564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1488 10.4246H11.5039L13.1582 0.185547H15.8029L14.1488 10.4246Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7366 0.435917C23.2149 0.228745 22.3875 0 21.3644 0C18.7525 0 16.9132 1.39418 16.9019 3.38744C16.8802 4.85807 18.2188 5.67489 19.2199 6.16524C20.2432 6.66631 20.591 6.99335 20.591 7.43998C20.5806 8.12593 19.7642 8.44212 19.0027 8.44212C17.9467 8.44212 17.3809 8.2791 16.5211 7.89747L16.1728 7.73388L15.8027 10.0323C16.4231 10.3152 17.5659 10.5663 18.7525 10.5773C21.5277 10.5773 23.3344 9.20465 23.3558 7.08051C23.3663 5.91492 22.6595 5.02181 21.1357 4.292C20.2106 3.82351 19.6441 3.50761 19.6441 3.02826C19.655 2.59248 20.1233 2.14614 21.1675 2.14614C22.0273 2.12428 22.6591 2.33117 23.1377 2.53819L23.3769 2.64692L23.7366 0.435917Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2522 6.79727C27.47 6.20905 28.3081 3.93247 28.3081 3.93247C28.2971 3.95433 28.5255 3.33339 28.6561 2.9522L28.841 3.83445C28.841 3.83445 29.3418 6.28535 29.4506 6.79727C29.0372 6.79727 27.7746 6.79727 27.2522 6.79727ZM30.5169 0.185547H28.4711C27.8403 0.185547 27.361 0.370569 27.0888 1.03509L23.1602 10.4245H25.9353C25.9353 10.4245 26.3922 9.16072 26.4904 8.88855C26.7949 8.88855 29.4945 8.88855 29.8862 8.88855C29.9621 9.24802 30.2018 10.4245 30.2018 10.4245H32.6507L30.5169 0.185547Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2936 0.185547L6.70341 7.16761L6.42037 5.75156C5.9415 4.11763 4.43965 2.3424 2.76367 1.45971L5.13619 10.4137H7.93306L12.0903 0.185547H9.2936Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29886 0.185547H0.0435336L0 0.39243C3.31942 1.24211 5.5178 3.29024 6.42102 5.752L5.49597 1.04623C5.34367 0.392285 4.87564 0.207118 4.29886 0.185547Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7539_15564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6498,
    height: 10.5773,
    fill: "white"
  })))));
};
export { SvgVisa as ReactComponent };